<template>
  <div class="vue-select-utility-type-dropdown-wrap">
    <div>
        <select @change="onUtilityTypeSelectChange($event)" name="utilites">
          <option v-for="utilityType in utilityTypesForDropdown" v-bind:selected="utilityType.selected" :key="utilityType.utilityTypeId" :value="utilityType.utilityTypeId">{{utilityType.name}}</option>
        </select>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'SelectCountyDropdown',
  props: {
      utilityTypes: Array,
      utilityTypeSelected: Function
  },
  data() {
    return {
      placeholderUtilityTypeId: 999,
      utilityTypesForDropdown: undefined
    }
  },
  async created() {
    this.processUtilityTypesForDropdown(this.utilityTypes);
  },
  watch: {
    utilityTypes: function (utilityTypes) {
      this.processUtilityTypesForDropdown(utilityTypes);
    }
  },
  methods: {
    onUtilityTypeSelectChange(event) {
      const utilityTypeId = parseInt(event.target.value, 10);
      const matchingUtilityType = lodash.find(this.utilityTypesForDropdown, utilityType => utilityType.utilityTypeId === utilityTypeId);

      if (!matchingUtilityType) {
        this.utilityTypeSelected();
        return;
      }

      this.utilityTypeSelected(matchingUtilityType);
    },
    processUtilityTypesForDropdown(utilityTypes) {
      this.utilityTypesForDropdown = JSON.parse(JSON.stringify(utilityTypes));

      this.utilityTypesForDropdown.unshift({
        countyId: this.placeholderUtilityTypeId,
        name: 'Please select a utility type',
        selected: true
      });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
